<template>
  <div
    id="newsletter"
    class="newsletter"
    v-if="newsletter && newsletter.newsletter_iframe"
  >
    <h4 class="newsletter-title">{{ newsletter.newsletter_text }}</h4>
    <div id="mc4_popup_simple" class="mc4_popup_simple">
      <button @click="togglePopup" class="btn btn-primary showMe">
        <StyledIcon
          iconsColor="#2A2E34"
          class="icon"
          v-html="svgIcons.envelope"
        />
        <span>{{ newsletter.newsletter_button }}</span>
      </button>

      <div id="mc4_popup_body" ref="newsletterPopup" v-once>
        <div class="mc4_popup_inner">
          <button @click="togglePopup" class="close_me">
            <span>Lukk</span>
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Nye-sider"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Visning-av-påmeldingsskjema"
                  transform="translate(-970.000000, -219.000000)"
                  fill="#FFFFFF"
                  fill-rule="nonzero"
                >
                  <g id="Group-3" transform="translate(910.000000, 215.000000)">
                    <g id="cross" transform="translate(60.000000, 4.000000)">
                      <polygon
                        id="Shape"
                        points="20 1.17660131 18.8405556 0.0197058824 10 8.84339869 1.15941176 0.0197058824 0 1.17660131 8.84058824 10.0003595 0 18.8234314 1.15941176 19.9802941 10 11.1572222 18.8405556 19.9802941 20 18.8234314 11.1587908 10.0003595"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <div id="mc4_popup_content" style="height: 100%; width: 100%;">
            <iframe src="" ref="iframe" />
          </div>
        </div>
        <div @click="togglePopup" class="popup_overlay"></div>
      </div>
    </div>
  </div>
</template>

<script>
import StyledIcon from "@/components/elements/StyledIcon";

export default {
  name: "newsletter",
  data() {
    return {
      newsletter: window.WPVUE.options.newsletter,
      insertedIframe: null,
      showNewsletter: false
    };
  },
  computed: {},
  components: {
    StyledIcon
  },
  mounted() {
    $("#mc4_popup_body").insertAfter("#content");
  },
  methods: {
    togglePopup() {
      const VM = this;
      jQuery("#mc4_popup_body").toggleClass("showMe");
      if (VM.insertedIframe === null) {
        VM.insertedIframe = true;
        VM.$refs.iframe.contentWindow.location.replace(
          VM.newsletter.newsletter_iframe
        );
      }
      jQuery("body").toggleClass("showMC4Popup");
      VM.showNewsletter = !VM.showNewsletter;
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

#mc4_popup_body .mc4_popup_inner {
  background-color: #fff;
  width: 600px;
  height: 781px;
  overflow-y: visible;
}
#mc4_popup_body .mc4_popup_inner iframe {
  width: 100%;
  height: 100%;
}
#mc4_popup_body {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  transition: 0.15s ease-in-out;
}
#mc4_popup_body.showMe {
  opacity: 1;
  visibility: visible;
  z-index: 9999;
}
#mc4_popup_body .mc4_popup_inner {
  overflow-y: auto;
  z-index: 2;
  width: 480px;
  max-width: 95%;
  max-height: 95%;
  position: relative;
  background: #fff;
  padding: 0px;
  width: 600px;
  height: 781px;
  overflow-y: visible;
}
#mc4_popup_body .mc4_popup_inner .close_me {
  border: none;
  box-shadow: none;
  color: #fff;
  background-color: transparent;
  position: absolute;
  right: 0;
  top: -35px;
  cursor: pointer;
}
#mc4_popup_body .mc4_popup_inner .close_me span {
  margin-right: 0;
  margin-right: 11px;
  font-weight: 300;
}
#mc4_popup_body .mc4_popup_inner form {
  margin-bottom: 0;
}
#mc4_popup_body .mc4wp-form-fields {
}
#mc4_popup_body .popup_overlay {
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(21, 38, 52, 0.6);
  cursor: pointer;
}
#mc4_popup_body .mc4_popup_inner form input {
  border-radius: 0;
}
/*        #mc4_popup_simple button.showMe span{
           padding-right:  80px;
           padding-left:  15px;
       }

       #mc4_popup_simple button.showMe{
           display: flex;
           cursor: pointer;
           padding: 12px 20px;
           margin: 0 auto;
           align-items: center;
           font-weight: 300;
           border: 2px solid #657079;
           box-shadow: none;
           border-radius: 0;
            color: #fff;
            background-color: #364550;
       } */
#mc4_popup_body .mc4_title {
  font-size: 22x;
}
#mc4_popup_body .mc4_popup_inner iframe {
  width: 100%;
  height: 100%;
  box-shadow: none;
  border: none;
}
@media all and (max-width: 767px) {
  #mc4_popup_body .mc4_popup_inner .close_me {
    position: sticky;
    right: 0;
    left: 0;
    width: 100%;
    width: calc(100% + 32px);
    top: 0px;
    display: block;
    margin-top: -15px;
    margin-left: -16px;
    margin-right: -16px;
    z-index: 20;
    background: #3f51b5;
    padding: 4px 10px;
    cursor: pointer;
  }
  #mc4_popup_body .mc4_title {
    font-size: 18px;
  }
  button.showMe {
    padding: 10px 15px;
  }
  button.showMe span {
    padding-right: 0px;
    padding-left: 8px;
    font-size: 14px;
  }
  button.showMe svg {
    transform: scale(0.8);
  }
  button.showMe svg.arrow {
    display: none;
  }
}
</style>
